import { Component, OnInit } from '@angular/core';
import { Message } from "primeng/components/common/message";
import { SelectItem } from "primeng/components/common/selectitem";
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { EventsService } from "../../../services/events.service";
import { EditEventModel } from "../../../models/inModels/Event";
import { StorageService } from '../../../services/system/storage.service';

@Component({
  selector: 'app-event-edit',
  templateUrl: './event-edit.component.html',
  styleUrls: ['./event-edit.component.css']
})
export class EventEditComponent implements OnInit {
	id;
	model: EditEventModel;
	loading = false;
	error: Message[];
	categories: SelectItem[];
	selectedCategory;
	uploading = false;
	events;
	selectedEventType;
	eventTypeId: SelectItem[];

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private service: EventsService,
	    private storageService: StorageService) {
		this.id = this.route.snapshot.paramMap.get('Id');
	}

	ngOnInit() {
		this.getJobPost();
	}

	getJobPost() {
		this.loading = true;
		this.service.get(this.id).then(
			result => {
				this.model = new EditEventModel(result);
				this.selectedEventType = {values: result.EventTypeId, label: result.EventType};
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}
	

	goBack(): void {
		this.router.navigate(['/events']);
	}

	save() {
		this.loading = true;
		this.service.update(this.model).then(
			result => {
				this.loading = false;
				this.model = new EditEventModel(result);
				this.error = [];
				this.error.push({ severity: 'success', summary: 'Success', detail: "Event saved" });
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
		
	}

	handleImage(event): void {
		var result = this.storageService.handleSuccess(event);
		
		this.model.coordinatorsPictureId = result.PublicId;
		this.loading = false;
	}

	handleError(event): void {
		this.loading = false;
		this.error = [];
		this.storageService.handleError(event, this.error);
	}

	removeImage(): void {
		this.model.coordinatorsPictureId = null;
		this.loading = false;
	}

	initTypeDropDown(): void {
		this.service.getDropdownList().then(
			x => {
				this.events = x;
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	setEventType(): void {
		this.model.eventTypeId = this.selectedEventType.value;
	}
}



// WEBPACK FOOTER //
// ./src/app/components/events/event-edit/event-edit.component.ts